// extracted by mini-css-extract-plugin
module.exports = {"skillLevelsTabs":"SkillLevelsTabs_skillLevelsTabs__LK9hm"};